(() => {
  /** Initialize gift-wrap controls once per product section. */
  const initialize = (root) => {
    if (!root || root.dataset.giftWrapInitialized) return;
    root.dataset.giftWrapInitialized = 'true';
    const dialog = root.querySelector('[data-gift-video]');
    const video = dialog?.querySelector('video');
    const template = root.querySelector('[data-gift-video-button]');
    const stickyForm = root.querySelector('#sticky-product-form');

    /** Attach a video trigger to the supplied gift-wrap row. */
    const addVideoButton = (row) => {
      if (!template || !dialog) return;
      const button = template.content.firstElementChild.cloneNode(true);
      button.addEventListener('click', () => dialog.showModal());
      row.append(button);
    };
    dialog?.querySelector('button').addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog?.addEventListener('close', () => {
      video.pause();
      video.currentTime = 0;
    });

    /** Enhance the app widget after insertion and route wrapped sticky purchases. */
    const enhance = () => {
      const widget = root.querySelector('.NullsgifDiv');
      const checkbox = widget?.querySelector('#NullsgiftWrap');
      const price = widget?.querySelector('.NullsgiftWrapFiyat');
      if (!checkbox || !price || widget.dataset.giftWrapEnhanced) return;
      widget.dataset.giftWrapEnhanced = 'true';
      widget.classList.add('product-gift-wrap');
      const label = document.createElement('label');
      label.className = 'product-gift-wrap__label';
      label.append(checkbox, document.createTextNode('Gift wrap '), price);
      widget.prepend(label);
      addVideoButton(widget);
      const form = checkbox.form;
      const submit = form?.querySelector('[type="submit"]');
      const details = root.querySelector('#NullssureGiftWrap');
      if (details) checkbox.setAttribute('aria-controls', details.id);
      const note = root.querySelector('#nullsNote');
      if (note) note.setAttribute('aria-label', 'Gift note');

      let stickyCheckbox;
      if (stickyForm && stickyForm !== form) {
        const row = document.createElement('div');
        row.className = 'product-gift-wrap product-gift-wrap--sticky';
        const stickyLabel = document.createElement('label');
        stickyLabel.className = 'product-gift-wrap__label';
        stickyCheckbox = document.createElement('input');
        stickyCheckbox.type = 'checkbox';
        stickyLabel.append(stickyCheckbox, document.createTextNode(`Gift wrap ${price.textContent.trim()}`));
        row.append(stickyLabel);
        addVideoButton(row);
        stickyForm.prepend(row);
        stickyCheckbox.addEventListener('change', () => {
          if (checkbox.checked !== stickyCheckbox.checked) checkbox.click();
          if (checkbox.checked) {
            widget.scrollIntoView({ behavior: 'smooth', block: 'center' });
            note?.focus({ preventScroll: true });
          }
        });
        // The app binds only to the main button. Route wrapped sticky purchases
        // through that button so the app adds the same gift product and note.
        stickyForm.addEventListener('click', (event) => {
          if (!checkbox.checked || !event.target.closest('[type="submit"]')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!stickyForm.reportValidity()) return;
          const quantity = stickyForm.elements.namedItem('quantity');
          const mainQuantity = form.elements.namedItem('quantity');
          if (quantity && mainQuantity) {
            mainQuantity.value = quantity.value;
            mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (!form.reportValidity()) return;
          submit?.click();
        }, true);
      }

      /** Mirror the app checkbox state and prevent accelerated checkout from bypassing gift wrap. */
      const sync = () => {
        checkbox.setAttribute('aria-expanded', String(checkbox.checked));
        if (stickyCheckbox) stickyCheckbox.checked = checkbox.checked;
        // Accelerated checkout bypasses the app's Add to cart handler.
        root.querySelectorAll('.shopify-payment-button').forEach((payment) => {
          if (checkbox.checked && !payment.hidden) {
            payment.dataset.giftWrapHidden = 'true';
            payment.hidden = true;
          } else if (!checkbox.checked && payment.dataset.giftWrapHidden) {
            payment.hidden = false;
            delete payment.dataset.giftWrapHidden;
          }
        });
      };
      checkbox.addEventListener('change', sync);
      sync();
      // Validate before the app's click handler adds a gift box separately.
      form?.addEventListener('click', (event) => {
        if (!checkbox.checked || !event.target.closest('[type="submit"]')) return;
        if (submit.disabled || submit.getAttribute('aria-disabled') === 'true' || !form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    };
    enhance();
    const observer = new MutationObserver(enhance);
    observer.observe(root, { childList: true, subtree: true });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === root) observer.disconnect();
    });
  };
  /** Initialize product sections containing the gift video template. */
  const initializeAll = () => document.querySelectorAll('.shopify-section:has([data-gift-video-button])').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
